import React, { memo, Fragment, useState } from 'react'
import { string, array, exact, func, bool, number, object } from 'prop-types'
import { insertValuesInTranslation } from '../../../helpers/string-helpers'
import { COUNTRY, LOCATION, EMPTY_ARRAY } from '../../../helpers/constants'
import Icon from '../icon/icon'
import Autocomplete from './autocomplete'
import Label from './label'

const translations = NFT.I18n.single_info_request

const LocationFields = memo(({
  countryOptions = EMPTY_ARRAY,
  locationOptions = EMPTY_ARRAY,
  country,
  location,
  errors = {},
  onChange,
  forceEditableState
}) => {
  const [isEditable, setIsEditable] = useState(forceEditableState || !country.value || !location.value)
  const countryTitleText = countryOptions.length === 1 &&
    insertValuesInTranslation(NFT.I18n.only_available_in, { country: countryOptions[0].label })
  return (isEditable
    ? <Fragment>
      <Autocomplete
        label={translations.country}
        options={countryOptions}
        value={country}
        fieldName={COUNTRY}
        titleText={countryTitleText || null}
        errorMessage={errors[COUNTRY]}
        onValueChange={value => onChange(COUNTRY, value)} />
      <Autocomplete
        label={translations.city}
        options={locationOptions}
        value={location}
        fieldName={LOCATION}
        errorMessage={errors[LOCATION]}
        onValueChange={value => onChange(LOCATION, value)} />
    </Fragment>
    : <div className='nft-field'>
      <Label text={translations.location} />
      <p className='nft-user-location__content'>
        <span className='nft-user-location__values'>{`${location.label}, ${country.label}`}</span>
        <a className='nft-user-location__edit-btn' onClick={() => setIsEditable(true)}>
          <Icon svg='edit' withoutFill /> {translations.edit}
        </a>
      </p>
    </div>)
});

LocationFields.propTypes = {
  countryOptions: array.isRequired,
  locationOptions: array.isRequired,
  country: exact({ label: string, value: string }),
  location: exact({ label: string, value: string, world_city_id: number }),
  errors: object,
  onChange: func.isRequired,
  forceEditableState: bool
}

LocationFields.displayName = 'LocationFields';

export default LocationFields